// Single source of truth for the "Currently:" status strip in the hero.
// Update this file (~ once a month) and every surface that reads from it
// updates automatically. Keep each field to one short clause.

export const currentStatus = {
  working: "Building Authgent (OAuth 2.1 for AI agents) \u00b7 researching agentic delegation primitives",
  open: "Staff / Principal IC roles \u2014 AI-agent identity, agentic platforms, or auth infrastructure",
  lastShipped: "Authgent v0.4 \u00b7 InfoQ DPoP article (April 2026)",
  // ISO date — renders as relative time ("updated 3 days ago") in the UI.
  lastUpdated: "2026-04-28",
};
